import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { CTA } from '../../../../../';
import { isValidArray } from '../../../../../utilities/validations';
import { useHoverConfig } from '../../../../../../hooks/use-hover-config';

import Tile from './tile';
import MenuHoverCard from '../../../../../third-party/hover/menu-card';

const ProductMenu = ({ data, smallCol, className, ...other }) => {
	const { hover_cards } = useHoverConfig();

	const windowCard = hover_cards?.find((card) => card.placement.includes('menu'));
	const doorCard = hover_cards?.find((card) => card.placement.includes('menu_door'));
	const isDoors = data?.secondary_heading !== '';

	return (
		<div className={`productMenu grid grid-cols-[1fr_321px] overflow-auto ${smallCol ? 'max-h-[calc(100vh-200px)]' : 'max-h-[calc(100vh-150px)]'} ${className || ''}`}>
			<div className='px-12 py-4'>
				<div className={`grid ${smallCol ? 'grid-cols-[minmax(min-content,350px)_minmax(min-content,350px)] ultra:grid-cols-4' : 'grid-cols-[1.85fr_1fr] ultra:grid-cols-[1fr_300px_300px_275px]'} gap-12 ultra:gap-x-6`}>
					{data?.category
						?.filter((cat) => !['get started', 'resources', 'inspiration'].includes(cat.category_type))
						?.map((category, index) => (
							<div
								className='pellaNav-gridCol'
								key={index}
							>
								{isValidArray(category?.group) && (
									<div
										className='pellaProductMenu'
										aria-label='Sub Navigation'
										{...other}
									>
										{category?.heading && <p className='mb-2 text-xl'>{category.heading}</p>}

										<div className={`grid gap-y-4 px-2 ${category.category_type === 'parts' && !smallCol ? 'w-1/2 ultra:w-full' : ''} ${category?.group?.length > 4 ? 'grid-cols-2 gap-x-6' : 'grid-cols-1'}`}>
											{category?.group?.map((tile, index) => (
												<Tile
													data={tile}
													key={index}
												/>
											))}
										</div>
									</div>
								)}

								{category.category_type === 'material' && (
									<div>
										{category.heading && <p className='mb-2 text-xl'>{category.heading}</p>}

										<div className='space-y-4 px-4'>
											{category.materials.map((material, index) => (
												<div key={index}>
													{isValidArray(material.cta_heading) && (
														<CTA
															data={material.cta_heading[0]}
															renderAs='link'
															className='text-base font-bold text-neutral-600 no-underline hover:border-b hover:border-b-neutral-600 focus:border-b focus:border-b-neutral-600'
														/>
													)}
													<p className='leading-tight'>
														{material.entries.map((link, index) => (
															<span
																className='after:content-[",_"] [&:last-child]:after:content-none'
																key={index}
															>
																<CTA
																	data={link}
																	renderAs='link'
																	className='text-xs font-semibold text-neutral-600 no-underline hover:border-b hover:border-b-neutral-600 focus:border-b focus:border-b-neutral-600'
																/>
															</span>
														))}
													</p>
												</div>
											))}
										</div>
									</div>
								)}
							</div>
						))}
				</div>

				{isValidArray(data?.shop_all_cta) && (
					<CTA
						className='mt-6 inline-block text-base font-semibold uppercase ultra:mt-12'
						data={data.shop_all_cta[0]}
					/>
				)}
			</div>

			<div className='h-full bg-neutral-25 ultra:grid-rows-1'>
				{data?.secondary_heading !== 'Patio Doors' && (
					<MenuHoverCard
						data={isDoors ? doorCard : windowCard}
						className='[&_img]:aspect-[1.77]'
					/>
				)}

				<div className='px-6 py-5'>
					{data?.category
						?.filter((cat) => ['resources', 'inspiration'].includes(cat.category_type))
						?.map((category, index) => (
							<div
								key={index}
								className={index === 0 ? 'mb-12' : ''}
							>
								{category.heading && <p className='mb-4 text-xl text-black'>{category.heading}</p>}
								{isValidArray(category.entries) && (
									<List
										bullets='none'
										className='space-y-2 text-base'
									>
										{category.entries.map((link, index) => (
											<li key={index}>
												<CTA
													data={link}
													className={`no-underline hover:border-b hover:border-b-current focus:border-b focus:border-b-current ${category.category_type === 'inspiration' ? 'font-bold text-neutral-600' : 'text-neutral-700'}`}
												/>
											</li>
										))}
									</List>
								)}
							</div>
						))}
				</div>
			</div>
		</div>
	);
};

ProductMenu.propTypes = {
	data: PropTypes.object,
	smallCol: PropTypes.bool,
	className: PropTypes.string,
};

export default ProductMenu;
